import Vue from 'vue'
import Router from 'vue-router'
import store from './store';
import { Role } from '@/data/roles'

Vue.use(Router)

const router = new Router({
    // mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/login',
            name: 'login',
            component: () => import(/* webpackChunkName: "login" */ '@/views/Login.vue')
        },
        {
            path: '/home',
            name: 'home',
			component: () => import(/* webpackChunkName: "home" */ '@/views/Home.vue')
        },
        {
            path: '/lista-escolas',
            name: 'lista-escolas',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "lista-escolas" */ '@/views/ListaEscolas.vue'),
			// meta: { authorize: [Role.Admin, Role.Mentor] }
        },
        {
            path: '/lista-turmas/:escolaId',
            name: 'lista-turmas',
            component: () => import(/* webpackChunkName: "lista-turmas" */ '@/views/ListaTurmas.vue')
        },
        {
            path: '/turma-informacoes/:turmaId',
            name: 'turma-informacoes',
            component: () => import(/* webpackChunkName: "turma-informacoes" */ '@/views/TurmaInformacoes.vue'),
			// meta: { authorize: [Role.Admin] }
        },
        {
            path: '/lista-alunos/:turmaId',
            name: 'lista-alunos',
            component: () => import(/* webpackChunkName: "lista-alunos" */ '@/views/ListaAlunos.vue')
        },
        {
            path: '/aluno-informacoes/:alunoId',
            name: 'aluno-informacoes',
            component: () => import(/* webpackChunkName: "aluno-informacoes" */ '@/views/AlunoInformacoes.vue')
        },
        {
            path: '/aluno-notas/:alunoTurmaId',
            name: 'aluno-notas',
            component: () => import(/* webpackChunkName: "aluno-notas" */ '@/views/AlunoNotas.vue')
        },
        {
            path: '/pesquisa-alunos',
            name: 'pesquisa-alunos',
            component: () => import(/* webpackChunkName: "pesquisa-alunos" */ '@/views/PesquisaAlunos.vue'),
			meta: { authorize: [Role.Admin] }
        },
        {
            path: '/estatisticas',
            name: 'estatisticas',
            component: () => import(/* webpackChunkName: "estatisticas" */ '@/views/Estatisticas.vue'),
			meta: { authorize: [Role.Admin] }
        },
		{
			path: '*',
			redirect: '/home'
		}
    ]
});

router.beforeEach((to, from, next) => {
	const { authorize } = to.meta;
	const currentUser = store.getters.CurrentUser;
	// console.log('Current User: ', currentUser);
	// console.log('to.fullPath: ', to.fullPath);

	if (!to.fullPath.includes('/login')) {
		if (!currentUser) {
			// not logged in, so redirect to login page with the return url
			return next({ path: '/login', query: { returnUrl: to.path } });
		}
	}

	if (to.fullPath.includes('/login')) {
		if (currentUser) {
			// logged in, so redirect to home page
			return next({ path: '/home' });
		}
	}

	if (authorize) {
        // check if route is restricted by role
        if (authorize.length && !authorize.includes(currentUser.role)) {
            // role not authorised so redirect to home page
			alert('Não possui permissões para aceder a esta funcionalidade.');
			next({ path: '/home' })
        }
    }

	next();
});

export default router;